import React, { FC } from 'react'
import RedBulletList from 'src/components/ui/RedBulletList'

interface IBulletListProps {
  className?: string
  items: string[]
}

const StyledBulletList: FC<IBulletListProps> = ({ className, items }) => (
  <RedBulletList
    className={`space-y-5 text-lg font-palanquin font-bold tracking-base ${className}`}
  >
    {items.map((item) => (
      <li>{item}</li>
    ))}
  </RedBulletList>
)

StyledBulletList.defaultProps = {
  className: '',
}

export default StyledBulletList
